import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  en: require('./store/en.json'),
  th: require('./store/th.json')
  // Add more languages as needed
}

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en',
  messages
})

export default i18n
